import { Auth0Provider, useAuth0 } from "@auth0/auth0-react"
import { useNavigate } from "react-router-dom"
import { ReactNode, useEffect } from "react"

interface AppState {
    returnTo?: string
}

interface Auth0ProviderWithNavigateProps {
    children: ReactNode
}

const GoBackNavigation = () => {
    const { isAuthenticated } = useAuth0()
    const navigate = useNavigate()

    useEffect(() => {
        if (!isAuthenticated) return

        const preventGoBack = (event: PopStateEvent) => {
            event.preventDefault()
            navigate("/cards", { replace: true })
            window.history.pushState(null, "", window.location.href)
        }

        window.history.pushState(null, "", window.location.href)
        window.addEventListener("popstate", preventGoBack)

        return () => window.removeEventListener("popstate", preventGoBack)
    }, [isAuthenticated, navigate])

    return null
}

export const Auth0ProviderWithNavigate = ({
                                              children,
                                          }: Auth0ProviderWithNavigateProps) => {
    const navigate = useNavigate()

    const domain = import.meta.env.VITE_AUTH0_DOMAIN as string
    const clientId = import.meta.env.VITE_AUTH0_CLIENT_ID as string
    const redirectUri = import.meta.env.VITE_AUTH0_CALLBACK_URL as string
    const audience = import.meta.env.VITE_AUTH0_AUDIENCE as string | undefined

    const onRedirectCallback = (appState?: AppState) => {
        navigate(appState?.returnTo || "/cards", { replace: true })
    }

    if (!(domain && clientId && redirectUri)) {
        console.warn("Auth0 configuration is missing required values")
        return null
    }

    return (
        <Auth0Provider
            domain={domain}
            clientId={clientId}
            authorizationParams={{
                audience,
                redirect_uri: redirectUri,
            }}
            onRedirectCallback={onRedirectCallback}
        >
            {children}
            <GoBackNavigation />
        </Auth0Provider>
    )
}
